import { useMemo, useState } from 'react';
import { analyticsConfig, grantAnalyticsConsent, denyAnalyticsConsent } from '../../utils/analytics';

const AnalyticsConsentBanner = () => {
  const shouldRequireConsent = analyticsConfig.requireConsent;
  const [consent, setConsent] = useState(
    typeof window !== 'undefined'
      ? localStorage.getItem(analyticsConfig.consentStorageKey) || 'unknown'
      : 'unknown'
  );

  const visible = useMemo(
    () => shouldRequireConsent && consent === 'unknown',
    [consent, shouldRequireConsent]
  );

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-shayek-dark-100 border-t border-shayek-light-300 dark:border-shayek-dark-200 p-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center gap-3 md:justify-between">
        <p className="text-sm text-shayek-light-700 dark:text-shayek-dark-700">
          We use analytics cookies to improve product quality and measure feature usage.
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-shayek-dark-200 text-shayek-light-800 dark:text-shayek-dark-800 text-sm"
            onClick={() => {
              denyAnalyticsConsent();
              setConsent('denied');
            }}
          >
            Reject
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-shayek-primary dark:bg-shayek-primary-600 text-white text-sm"
            onClick={() => {
              grantAnalyticsConsent();
              setConsent('granted');
            }}
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentBanner;
